import React, { useState, useEffect } from "react";
import Navbar from "../components/helpers/Navbar";
import AddPersonModal from "../components/aplicatii-membru/AddPersonModal";
import PersonTable from "../components/aplicatii-membru/PersonTable";
import Footer from "../components/helpers/Footer";

const API_BASE = "https://prdp-api.suport-949.workers.dev/api/inscrieri-membri";
const API_MEMBRI = "https://prdp-api.suport-949.workers.dev/api/membri";
const API_VOLUNTARI = "https://prdp-api.suport-949.workers.dev/api/voluntari";

// Token hardcodat pentru autentificare Bearer
const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

const AplicatiiMembru = () => {
  const [people, setPeople] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  useEffect(() => {
    const fetchPeople = async () => {
      try {
        const response = await fetch(API_BASE, {
          headers: AUTH_HEADER,
        });
        if (response.ok) {
          const data = await response.json();
          setPeople(data);
        }
      } catch (error) {
        console.error("Eroare la preluarea aplicațiilor:", error);
      }
    };
    fetchPeople();
  }, []);

  const addOrEditPerson = async (person) => {
    const newPerson = { ...person, timestamp: new Date().toISOString() };
    try {
      if (selectedPerson) {
        await fetch(`${API_BASE}/${selectedPerson.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(newPerson),
        });
        setPeople((prev) =>
          prev.map((p) => (p.id === selectedPerson.id ? newPerson : p))
        );
      } else {
        const response = await fetch(API_BASE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(newPerson),
        });
        const addedPerson = await response.json();
        setPeople((prev) => [...prev, addedPerson]);
      }
      handleHideModal();
    } catch (error) {
      console.error("Eroare la salvarea aplicației:", error);
      alert("A apărut o eroare la salvare");
    }
  };

  const deletePerson = async (id) => {
    try {
      await fetch(`${API_BASE}/${id}`, {
        method: "DELETE",
        headers: AUTH_HEADER,
      });
      setPeople((prev) => prev.filter((p) => p.id !== id));
    } catch (error) {
      console.error("Eroare la ștergere:", error);
    }
  };

  const handleAccept = async (person) => {
    try {
      const isMembru = person.membru || person.membruVoluntar;
      const isVoluntar = person.voluntar || person.membruVoluntar;

      const requests = [];
      let messageParts = [];

      if (isMembru) {
        const membruData = {
          nume: person.nume,
          prenume: person.prenume,
          email: person.email,
          telefon: person.telefon || "0000000000",
          oras: person.oras,
          judet: person.judet,
          tara: person.tara,
          cnp: person.cnp || "0000000000000",
          serie_numar_ci: person.serie_numar_ci || "De completat",
          adresa: person.adresa || "De completat",
          tip_cotizatie: "lunar",
          data_start: new Date().toISOString().split("T")[0],
          data_sfarsit: new Date().toISOString().split("T")[0],
          status_membru: "activ",
        };
        requests.push(
          fetch(API_MEMBRI, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...AUTH_HEADER,
            },
            body: JSON.stringify(membruData),
          })
        );
        messageParts.push("membru");
      }

      if (isVoluntar) {
        const voluntarData = {
          prenume: person.prenume,
          nume: person.nume,
          telefon: person.telefon,
          email: person.email,
          oras: person.oras,
          judet: person.judet,
          tara: person.tara,
        };
        requests.push(
          fetch(API_VOLUNTARI, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              ...AUTH_HEADER,
            },
            body: JSON.stringify(voluntarData),
          })
        );
        messageParts.push("voluntar");
      }

      const responses = await Promise.all(requests);
      const allSuccess = responses.every((r) => r.ok);
      if (!allSuccess) throw new Error("Una dintre operații a eșuat");

      await fetch(`${API_BASE}/${person.id}`, {
        method: "DELETE",
        headers: AUTH_HEADER,
      });

      setPeople((prev) => prev.filter((p) => p.id !== person.id));

      let message = "Persoana a fost adăugată ca ";
      if (messageParts.length === 2) {
        message += "membru și voluntar.";
      } else if (messageParts.length === 1) {
        message += messageParts[0] + ".";
      } else {
        message = "Persoana a fost adăugată cu succes.";
      }

      setPopupMessage(message);
      setShowPopup(true);
    } catch (error) {
      console.error("Eroare la procesarea cererii:", error);
      alert(`Eroare: ${error.message}`);
    }
  };

  const handleEdit = (person) => {
    setSelectedPerson(person);
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
    setSelectedPerson(null);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupMessage("");
  };

  const popupStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#f0f0f3",
    borderRadius: "24px",
    boxShadow:
      "inset 4px 4px 12px #d1d9e6, inset -4px -4px 12px #ffffff, 4px 4px 16px #d1d9e6",
    padding: "32px 40px 24px 40px",
    minWidth: "350px",
    maxWidth: "95vw",
    textAlign: "left",
    zIndex: 1050,
    fontSize: "20px",
    color: "#222",
    fontWeight: 500,
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.14)",
    zIndex: 1040,
  };

  const neumorphButton = {
    background: "#e9eaf0",
    color: "#3a4a6b",
    border: "none",
    borderRadius: "12px",
    boxShadow: "2px 2px 6px #d1d9e6, -2px -2px 6px #fff",
    padding: "8px 28px",
    fontSize: "16px",
    fontWeight: 600,
    marginRight: "8px",
    marginTop: "16px",
    transition: "all 0.15s",
    outline: "none",
  };

  const neumorphButtonAccent = {
    ...neumorphButton,
    background: "#4d6ec5",
    color: "#fff",
    boxShadow: "2px 2px 8px #d1d9e6, -2px -2px 8px #fff",
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <h2 className="mb-4 text-center text-primary-dark">
          Aplicări membru/voluntar
        </h2>
        <button
          className="btn btn-primary btn-primary-admin mb-3"
          onClick={() => {
            setSelectedPerson(null);
            setShowModal(true);
          }}
        >
          Adaugă aplicație nouă
        </button>

        <PersonTable
          people={people}
          onDelete={deletePerson}
          onEdit={handleEdit}
          onAccept={handleAccept}
        />

        <AddPersonModal
          show={showModal}
          onHide={handleHideModal}
          onSave={addOrEditPerson}
          initialData={selectedPerson}
        />

        {showPopup && (
          <>
            <div style={overlayStyle} onClick={closePopup}></div>
            <div style={popupStyle}>
              <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 18 }}>
                Succes!
              </div>
              <div>{popupMessage}</div>
              <div style={{ textAlign: "right" }}>
                <button style={neumorphButtonAccent} onClick={closePopup}>
                  Închide
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AplicatiiMembru;
